import {
  DATA_CONNECTOR_AIRTABLE_GET_TABLES_BEGIN,
  DATA_CONNECTOR_AIRTABLE_GET_TABLES_SUCCESS,
  DATA_CONNECTOR_AIRTABLE_GET_TABLES_FAILURE,
  DATA_CONNECTOR_AIRTABLE_GET_TABLES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function airtableGetTables(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_AIRTABLE_GET_TABLES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/get-tables`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_GET_TABLES_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_GET_TABLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAirtableGetTablesError() {
  return {
    type: DATA_CONNECTOR_AIRTABLE_GET_TABLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_AIRTABLE_GET_TABLES_BEGIN:
      return {
        ...state,
        airtableGetTablesPending: true,
        airtableGetTablesError: null,
      };

    case DATA_CONNECTOR_AIRTABLE_GET_TABLES_SUCCESS:
      return {
        ...state,
        airtableGetTablesPending: false,
        airtableGetTablesError: null,
        airtableTables: action.data,
      };

    case DATA_CONNECTOR_AIRTABLE_GET_TABLES_FAILURE:
      return {
        ...state,
        airtableGetTablesPending: false,
        airtableGetTablesError: action.data.error,
      };

    case DATA_CONNECTOR_AIRTABLE_GET_TABLES_DISMISS_ERROR:
      return {
        ...state,
        airtableGetTablesError: null,
      };

    default:
      return state;
  }
}
